import React from 'react'

const Dots = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 6.66675V6.67204M10 6.66675V6.67204M5 6.66675V6.67204M15 13.3282V13.3334M10 13.3282V13.3334M5 13.3282V13.3334" stroke="#202327" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default Dots
